import React, { useState } from "react";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { Mail } from "lucide-react";
import { toast } from "sonner";

export default function NewsletterSignup() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      const r = await api.post("/newsletter/subscribe", { email });
      if (r.data.status === "already_subscribed") {
        toast.info("You're already on the list, partner!");
      } else {
        toast.success("You're in. We'll holler when somethin' new drops.");
      }
      setEmail("");
    } catch (err) {
      toast.error(err?.response?.data?.detail?.[0]?.msg || "Invalid email");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="flex gap-2" data-testid="newsletter-form">
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="your@email.com"
        data-testid="newsletter-email-input"
        className="flex-1 bg-[#0A0E0B] border-2 border-[#2C332A] focus:border-[#DD5422] outline-none px-3 py-2 text-sm text-[#E5E5E5] placeholder:text-[#8D9688]"
      />
      <Button data-testid="newsletter-submit-btn" type="submit" disabled={loading}
        className="bg-[#DD5422] text-[#0A0E0B] hover:bg-[#FF6B35] rounded-none font-anton uppercase tracking-widest border-2 border-[#DD5422] px-4 h-auto">
        <Mail className="w-4 h-4" />
      </Button>
    </form>
  );
}
